import src from "IMAGE";
export default { src, width: 670, height: 601, blurWidth: 0, blurHeight: 0};
